import { render, staticRenderFns } from "./ESGconnectionsScore.vue?vue&type=template&id=66d52469"
import script from "./ESGconnectionsScore.vue?vue&type=script&lang=js"
export * from "./ESGconnectionsScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports